import React from 'react'

import Navigator from '../../app/navigator'
import { Application } from '../../domain/Application'
import { DashboardGranularity, SlimHistoryReportStats } from '../../domain/DashboardApplicationReport'
import { Organization } from '../../domain/Organization'
import LargeNumber from '../../helper/large-number'
import Milliseconds from '../../helper/milliseconds'
import Percent from '../../helper/percent'

interface Props {
    data: {
        granularity: DashboardGranularity
        range: { startDate: string; endDate: string; minutes: number }
        history: SlimHistoryReportStats
    }
    organization: Organization
    application: Application
    navigator: Navigator
}
class Box extends React.Component<Props> {
    public static displayName = 'Box'

    public componentDidMount() {
        jQuery('.tip').each(function() {
            ;(jQuery(this) as any).tooltip({
                html: true,
                title: jQuery('#' + jQuery(this).data('tip')).html(),
                placement: 'bottom',
            })
        })
    }

    public render() {
        const granularityLabels = {
            day: 'Yesterday',
            week: '7 Days',
            month: '30 Days',
        }

        const link = this.props.navigator.path('XhprofProfilerBundle.History.lastWeek', {
            granularity: this.props.data.granularity,
            date: this.props.data.range.endDate.substr(0, 10),
            organization: this.props.organization.name,
            application: this.props.application.name,
        })

        if (!this.props.data.history.current95Percentile && !this.props.data.history.currentRequests) {
            return (
                <div className="row">
                    <div className="col-md-3 text-right">
                        <a href={link}>{granularityLabels[this.props.data.granularity]}</a>
                    </div>
                    <div className="col-md-3 text-center">
                        <small>-</small>
                    </div>
                    <div className="col-md-3 text-center">
                        <small>-</small>
                    </div>
                    <div className="col-md-3 text-center">
                        <small>-</small>
                    </div>
                </div>
            )
        }

        const minutesPerGranularity = {
            day: 60 * 24,
            week: 7 * 60 * 24,
        }
        return (
            <div className="row">
                <div className="col-md-3 text-right">
                    <a href={link}>{granularityLabels[this.props.data.granularity]}</a>
                </div>
                <div className="col-md-3 text-center">
                    <span title="Response Time">
                        <Milliseconds value={this.props.data.history.current95Percentile * 1000} class="response-time" />
                        &nbsp;
                    </span>
                </div>
                <div className="col-md-3 text-center">
                    <span title="Request per minute">
                        <LargeNumber value={this.props.data.history.currentRequests / minutesPerGranularity[this.props.data.granularity]} />{' '}
                        rpm&nbsp;
                    </span>
                </div>
                <div className="col-md-3 text-center">
                    <span title="Failures">
                        <Percent value={this.props.data.history.errorRate / 100} class="error" />
                        &nbsp;
                    </span>
                </div>
            </div>
        )
    }
}

export default Box
